import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 4a1 1 0 0 1 .992.883L25 5v4h1.334c1.67 0 3.063 1.232 3.16 2.822L29.5 12v10a1 1 0 0 1-.883.993l-.117.007H25v4.5a1 1 0 0 1-.883.993l-.117.007H8a1 1 0 0 1-.993-.883l-.007-.117V23H3.5a1 1 0 0 1-.993-.883L2.499 22V12c0-1.616 1.334-2.905 2.983-2.995L5.666 9h1.332L7 5a1 1 0 0 1 .884-.993L7.999 4zm-1.001 16h-14v6.5h14zM5.666 11h20.667l.13.006c.596.056 1.036.496 1.036.994v9h-2.5v-2l-.006-.117a1 1 0 0 0-.994-.883H8l-.116.007a1 1 0 0 0-.884.993v2H4.5v-9l.007-.106c.061-.488.543-.894 1.16-.894M23.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M8.999 6h14v3h-14z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPrinter = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPrinter);
export default Memo;
